/**
 * Shared simulation constants (client + server).
 *
 * IMPORTANT: keep `dtMs` an integer so both client and server step the sim with the exact same value.
 */
export const ARCADE_SIM_DT_MS = 33;


